import React from "react";

import {
  Checkbox,
  Input,
  Button,
  InputNumber,
  Col,
  Row,
  Statistic,
  Image,
  Switch,
  Space,
} from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  CopyOutlined,
  QrcodeOutlined,
} from "@ant-design/icons";
import Base from "../../routes/Base";
import {
  getProductSkuPriceBoundsFromApi,
  formatSkuPriceRangeYuan,
} from "../../routes/product/productSpecHelpers";

const { Countdown } = Statistic;

export default class ProductListItem extends Base {
  static Actions = {
    Select: "SELECT",
    AddTag: "ADD_TAG",
    OnShell: "ON_SHELL",
    OffShel: "OFF_SHELL",
    Edit: "EDIT",
    EditConfirm: "EDIT_CONFIRM",
    Delete: "DELETE",
    AddDiscount: "ADD_DISCOUNT",
    RemoveDiscount: "REMOVE_DISCOUNT",
    Copy: "COPY",
    Clone: "CLONE",
    OnFreeShipping: "OnFreeShipping",
    OffFreeShipping: "OffFreeShipping",
    ShowDouyinOrder: "ShowDouyinOrder",
    ShowQrcode: "ShowQrcode",
  };

  constructor(props) {
    super(props);
    this.state = {
      inEditMode: false,
      editName: "",
      editPrice: "",
      editInPrice: "",
      editQuantity: "",
      editOrder: "",
      editNumber: "",
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.product.id !== this.props.product.id) {
      this.onActionCancelClick();
    }
  }

  render() {
    if (this.props.product) {
      let className = "product-list-item";
      if (this.isProductOffShell()) {
        className += " offShelf";
      }
      if (this.state.inEditMode) {
        className += " editmode";
      }

      return (
        <Col xs={24} sm={24} md={24} lg={12} xl={12}>
          <div className={className}>
            {this._renderInfo()}
            {this._renderSkuFlag()}
          </div>
        </Col>
      );
    }

    return null;
  }

  _renderInfo() {
    return (
      <div className="item-row">
        {this._renderInfoImage()}
        <div className="item-main">
          {this._renderInfoName()}
          <Row className="item-price">
            {this._renderInfoProductNumber()}
            {this._renderInfoQuantity()}
            {this._renderInfoOrder()}
            {this._rendeBarcode()}
          </Row>
          {this._renderActions()}
        </div>
      </div>
    );
  }

  _renderInfoImage() {
    const { images } = this.props.product;
    if (Array.isArray(images) && images.length > 0) {
      return (
        <div className="item-image">
          <div>
            <Image
              fallback="data:image/png;base64,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"
              alt=""
              src={images[0].url}
            />
            {this.isProductOffShell() ? (
              <div className="offShelf-mask">
                {this.i18n.t("product.productItem.offShelf")}
              </div>
            ) : null}
            <Checkbox
              checked={this.isProductSelected()}
              onChange={this.onCheckChange}
            />
          </div>
          <div className="item-price">
            {this._renderInPrice()}
            {this.renderInfoPrice()}
            {this._renderProductId()}
          </div>
        </div>
      );
    }
    return null;
  }

  _renderInfoName() {
    let name = this.i18n.getPropNameByLocale(this.props.product, "name");

    if (this.state.inEditMode) {
      return (
        <Input
          size="small"
          defaultValue={name}
          disabled={this.hasProductSku()}
          onChange={this.onNameChange}
        />
      );
    }

    return (
      <span className="item-name" onClick={this.onEditTriggerClick}>
        {name}
      </span>
    );
  }

  _renderInfoSales() {
    return (
      <div className="item-sales">
        <span>
          {this.i18n.t("product.productItem.monthySale", { count: "--" })}
        </span>
        <span>{this.i18n.t("product.productItem.likes", { count: "--" })}</span>
      </div>
    );
  }

  

  _renderInPrice() {
    if (!this.props.product.purchase_price) return null;

    let price = this.util.getPrice(this.props.product.purchase_price);

    return (
      <span className="input-block price">
        <span>{this.i18n.t("productEdit.inPriceLabelShort")}</span>
        <span className="item-price-input">￥{price}</span>
      </span>
    );
  }

  _renderProductId() {
    return (
      <span className="input-block price">
        <span>ID:</span>
        <span className="item-price-input">{this.props.product.id}</span>
      </span>
    );
  }

  renderInfoPrice() {
    const { product } = this.props;
    const skuBounds = getProductSkuPriceBoundsFromApi(product);
    const skuRangeText = formatSkuPriceRangeYuan(skuBounds);
    let price = skuRangeText || this.util.getPrice(product.price);
    let originalPrice = this.util.getPrice(product.original_price);
    let priceWrapper = "";
    let douyinOrderBtn = "";
    if (this.isJdShop()) {
      douyinOrderBtn = (
        <Button
          type="primary"
          size="small"
          className="stop-discount"
          onClick={() => this.onShowDouyinOrder(product)}
        >
          {this.i18n.t("productEdit.douyinOrder")}
        </Button>
      );
    }
    if (product.original_price) {
      priceWrapper = (
        <div>
          <div>
            <span>{this.i18n.t("productEdit.outPriceLabelShort")}</span>
            <span className="item-original-price-input">￥{originalPrice}</span>
            <span className="item-price-input real-price">
              {skuRangeText ? price : `￥${price}`}
            </span>
          </div>
          <div>
            {product.end_time && (
              <Countdown
                value={this.moment(product.end_time)}
                format="D:H:mm:ss"
                valueStyle={{ fontSize: 14, color: "#fff" }}
                style={{ backgroundColor: "#666", textAlign: "center" }}
              />
            )}
          </div>
          <Space>
            {!product.is_flash_sale && (
              <Button
                type="primary"
                size="small"
                className="stop-discount"
                onClick={() => this.onActionRemoveDiscount(product.id)}
              >
                {this.i18n.t("productEdit.restorePrice")}
              </Button>
            )}
            {douyinOrderBtn}
          </Space>
        </div>
      );
    } else {
      priceWrapper = (
        <div>
          <div>
            <span>{this.i18n.t("productEdit.outPriceLabelShort")}</span>
            <span className="item-price-input real-price">
              {skuRangeText ? price : `￥${price}`}
            </span>
          </div>
          <Space>
            <Button
              type="primary"
              size="small"
              className="stop-discount"
              onClick={() => this.onActionAddDiscount(product)}
            >
              {this.i18n.t("productEdit.priceDiscount")}
            </Button>
            {douyinOrderBtn}
          </Space>
        </div>
      );
    }

    return <span className="input-block price">{priceWrapper}</span>;
  }

  _renderInfoQuantity() {
    let quantity = this.i18n.t("product.productItem.quantityZero");
    if (this.isLbsShop()) {
      quantity = this.i18n.t("product.productItem.quantityLimitless");
    }
    if (this.props.product.quantity > 0) {
      quantity = this.props.product.quantity;
    }

    if (this.state.inEditMode) {
      return (
        <span className="input-block">
          <span>{this.i18n.t("product.productItem.quantity")}</span>
          <InputNumber
            size="small"
            min={0}
            defaultValue={quantity}
            onChange={this.onQuantityChange}
          />
        </span>
      );
    }

    return (
      <span className="input-block">
        <span>{this.i18n.t("product.productItem.quantity")}</span>
        <span
          className={`item-quantity-input ${
            this.props.product.quantity === 0 && "red"
          }`}
          onClick={this.onEditTriggerClick}
        >
          {quantity}
        </span>
      </span>
    );
  }

  _renderInfoOrder() {
    const { order } = this.props.product;
    if (!order || !order < 0) return null;

    if (this.state.inEditMode) {
      return (
        <span className="input-block">
          <span>{this.i18n.t("productEdit.orderLabel")}</span>
          <InputNumber
            size="small"
            min={0}
            defaultValue={order}
            onChange={this.onOrderChange}
          />
        </span>
      );
    }

    return (
      <span className="input-block">
        <span>{this.i18n.t("productEdit.orderLabel")}</span>
        <span className="item-quantity-input" onClick={this.onEditTriggerClick}>
          {order}
        </span>
      </span>
    );
  }

  _rendeBarcode() {
    const { barcode } = this.props.product;
    if (barcode) {
      return (
        <span className="input-block">
          <span>{this.i18n.t("productEdit.barcodeLabel")}</span>
          <span className="item-quantity-input red borderless">{barcode}</span>
        </span>
      );
    }
    return null;
  }

  _renderInfoProductNumber() {
    if (this.isBBShopMerchant() || this.isThirdPartyShop()) {
      const { product_no, jd_sku } = this.props.product;
      if (this.state.inEditMode) {
        return (
          <span className="input-block">
            <span>{this.i18n.t("productEdit.numberLabel")}</span>
            <Input
              size="small"
              defaultValue={product_no}
              onChange={this.onProductNumberChange}
            />
          </span>
        );
      }

      return (
        <span className="input-block">
          <span>{this.i18n.t("productEdit.numberLabel")}</span>
          <span
            className="item-product-number-input"
            onClick={this.onEditTriggerClick}
          >
            {product_no ?? jd_sku ?? "000000"}
          </span>
        </span>
      );
    }
    return null;
  }

  _renderActions() {
    let mainAction = (
      <Button size="small" onClick={this.onActionOffClick}>
        {this.i18n.t("product.productItem.actionDown")}
      </Button>
    );
    if (this.isProductOffShell()) {
      mainAction = (
        <Button size="small" type="primary" onClick={this.onActionOnClick}>
          {this.i18n.t("product.productItem.actionUp")}
        </Button>
      );
    }
    if (this.state.inEditMode) {
      mainAction = (
        <Button
          size="small"
          style={{ borderWidth: 0 }}
          type="primary"
          onClick={this.onActionConfirmClick}
        >
          {this.i18n.t("product.productItem.actionConfirm")}
        </Button>
      );
    }

    let actions = [];
    if (!this.state.inEditMode) {
      if (
        (this.isBBShopMerchant() || this.isThirdPartyShop()) &&
        this.shopHasAgents()
      ) {
        actions.push(
          <Button
            size="small"
            style={{ borderWidth: 0, backgroundColor: "transparent" }}
            key="action-copy"
            onClick={() => this.onActionCopyClick(this.props.product)}
          >
            <EditOutlined />
            {this.i18n.t("product.productItem.oneKeyCopy")}
          </Button>
        );
      }
      if (!this.isJdShop()) {
        actions.push(
          <Button
            size="small"
            style={{ borderWidth: 0, backgroundColor: "transparent" }}
            key="action-clone"
            onClick={this.onActionCloneClick}
          >
            <CopyOutlined />
            {this.i18n.t("product.productItem.actionClone")}
          </Button>
        );
        actions.push(
          <Button
            size="small"
            style={{ borderWidth: 0, backgroundColor: "transparent" }}
            key="action-qrcode"
            onClick={this.onActionQrcodeClick}
            title={this.i18n.t("product.productItem.actionQrcode")}
          >
            <QrcodeOutlined />
            {this.i18n.t("product.productItem.actionQrcode")}
          </Button>
        );
      }
      actions.push(
        <Button
          size="small"
          style={{ borderWidth: 0, backgroundColor: "transparent" }}
          key="action-delete"
          onClick={this.onActionDeleteClick}
        >
          <DeleteOutlined />
          {this.i18n.t("product.productItem.actionDelete")}
        </Button>
      );
      actions.push(
        <Button
          size="small"
          style={{ borderWidth: 0, backgroundColor: "transparent" }}
          key="action-edit"
          onClick={this.onActionEditClick}
        >
          <EditOutlined />
          {this.i18n.t("product.productItem.actionEdit")}
        </Button>
      );
    } else {
      actions.push(
        <Button
          size="small"
          style={{ borderWidth: 0 }}
          key="action-cancel"
          onClick={this.onActionCancelClick}
        >
          {this.i18n.t("product.productItem.actionCancel")}
        </Button>
      );
    }

    return (
      <Row className="item-row actions">
        {actions}
        {mainAction}
        <Switch
          checkedChildren={this.i18n.t("productEdit.freeShipping")}
          unCheckedChildren={this.i18n.t("productEdit.notFreeShipping")}
          checked={this.isProductFreeShipping()}
          style={{ margin: "0 10px" }}
          onChange={(value) => {
            if (value) {
              this.onActionFreeShipping();
            } else {
              this.onActionOffFreeShipping();
            }
          }}
        />
      </Row>
    );
  }

  _renderSkuFlag() {
    if (this.hasProductSku()) {
      return (
        <img
          className="sku-img"
          alt=""
          src={
            process.env.PUBLIC_URL + this.i18n.t("product.productItem.skuImage")
          }
        />
      );
    }

    return null;
  }

  onCheckChange = (e) => {
    this.fireActionToParent(ProductListItem.Actions.Select, e.target.checked);
  };

  onEditTriggerClick = () => {
    let state = {
      inEditMode: true,
      editPrice: this.props.product.display_price / 100,
      editInPrice: this.props.product.purchase_price / 100,
      editQuantity: this.props.product.quantity,
      editOrder: this.props.product.order,
      editNumber: this.props.product.product_no,
    };

    if (!this.hasProductSku()) {
      state.editName = this.i18n.getPropNameByLocale(
        this.props.product,
        "name"
      );
    }

    this.setState(state);
  };

  onNameChange = (e) => {
    this.setState({ editName: e.target.value });
  };

  onPriceChange = (e) => {
    this.setState({ editPrice: e });
  };

  onInPriceChange = (e) => {
    this.setState({ editInPrice: e });
  };

  onQuantityChange = (e) => {
    this.setState({ editQuantity: e });
  };

  onOrderChange = (e) => {
    this.setState({ editOrder: e });
  };

  onProductNumberChange = (e) => {
    this.setState({ editNumber: e.target.value });
  };

  onAddTagClick = () => {
    this.fireActionToParent(ProductListItem.Actions.AddTag);
  };

  onActionOffClick = () => {
    this.fireActionToParent(ProductListItem.Actions.OffShel);
  };

  onActionOnClick = () => {
    this.fireActionToParent(ProductListItem.Actions.OnShell);
  };

  onActionFreeShipping = () => {
    this.fireActionToParent(ProductListItem.Actions.OnFreeShipping);
  };

  onActionOffFreeShipping = () => {
    this.fireActionToParent(ProductListItem.Actions.OffFreeShipping);
  };

  onActionEditClick = () => {
    this.fireActionToParent(ProductListItem.Actions.Edit);
  };

  onActionCopyClick(product) {
    this.fireActionToParent(ProductListItem.Actions.Copy, product);
  }

  onActionDeleteClick = () => {
    this.fireActionToParent(ProductListItem.Actions.Delete);
  };

  onActionCloneClick = () => {
    this.fireActionToParent(ProductListItem.Actions.Clone);
  };

  onActionQrcodeClick = () => {
    this.fireActionToParent(ProductListItem.Actions.ShowQrcode, this.props.product);
  };

  onShowDouyinOrder = (product) => {
    this.fireActionToParent(ProductListItem.Actions.ShowDouyinOrder, product);
  };

  onActionAddDiscount = (product) => {
    this.fireActionToParent(ProductListItem.Actions.AddDiscount, product);
  };

  onActionRemoveDiscount = (id) => {
    this.fireActionToParent(ProductListItem.Actions.RemoveDiscount, id);
  };

  onActionConfirmClick = () => {
    this.setState({ inEditMode: false });
    let data = {
      price: this.state.editPrice * 100,
      purchase_price: this.state.editInPrice * 100,
      quantity: this.state.editQuantity,
      order: this.state.editOrder,
      product_no: this.state.editNumber,
    };
    if (!this.hasProductSku()) {
      data.name = this.state.editName;
    }
    this.fireActionToParent(ProductListItem.Actions.EditConfirm, data);
  };

  onActionCancelClick = () => {
    this.setState({
      inEditMode: false,
      editName: "",
      editPrice: "",
      editInPrice: "",
      editQuantity: "",
      editOrder: "",
      editNumber: "",
    });
  };

  /* custom method */

  isProductOffShell() {
    return this.props.product ? this.props.product.status === 0 : false;
  }

  isProductFreeShipping() {
    return this.props.product && this.props.product.is_free_shipping;
  }

  isProductSelected() {
    return this.props.product ? this.props.product.selected : false;
  }

  fireActionToParent(action, data) {
    if (this.props.onActionClick) {
      this.props.onActionClick(action, data);
    }
  }

  hasProductSku() {
    return this.props.product ? this.props.product.sku_id > 0 : false;
  }

  isBBShopMerchant() {
    return this.props.bbShopMerchant;
  }

  isThirdPartyShop() {
    return this.props.isThirdPartyShop;
  }

  showExtraContent() {
    return this.props.showExtraContent;
  }

  isJdShop() {
    return this.props.isJdShop;
  }

  isOnlineShops() {
    return this.isBBShopMerchant();
  }
}
